import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-website-development',
  templateUrl: './website-development.component.html',
  styleUrls: ['./website-development.component.scss']
})
export class WebsiteDevelopmentComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Web Development - Xipe Tech';
  contentDescription = 'XipeTech offers cutting-edge web development services, creating responsive, secure, and high-performance websites to help businesses achieve digital success.';
  contentKeywords = 'web development, responsive websites, custom web design, website development services, professional web development, business website solutions, secure web development, e-commerce development, modern web design, high-performance websites';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
